export const getLanguage = () => {
  if (window.location.href.includes('en/')) return 'en';
  return 'cs';
};

export const nativeNavigate = (route: string, language: 'cs' | 'en') => {
  const fullRoute = language === 'en' ? `/${language}/${route}` : `/${route}`;
  window.location.href = fullRoute;
};
